(() => {
  if (window.__mpCartInit) return;
  window.__mpCartInit = true;

  const root = () => window.Shopify?.routes?.root || '/';
  const settings = () => window.themeVariables?.settings || {};
  const strings = () => window.themeVariables?.strings || {};
  const emit = (target, name, detail) => target.dispatchEvent(new CustomEvent(name, { bubbles: true, detail }));

  const flashButton = (button, text) => {
    if (!button || !text) return;
    if (button._mpLabel === undefined) button._mpLabel = button.innerHTML;
    button.textContent = text;
    clearTimeout(button._mpTimer);
    button._mpTimer = setTimeout(() => {
      button.innerHTML = button._mpLabel;
      button._mpLabel = undefined;
    }, 2500);
  };

  const setBusy = (buttons, busy) => {
    buttons.forEach((button) => {
      if (busy) button.setAttribute('aria-busy', 'true');
      else button.removeAttribute('aria-busy');
      button.classList.toggle('is-loading', busy);
    });
  };

  const toPayload = (form) => {
    const payload = { quantity: 1, properties: {} };
    new FormData(form).forEach((value, key) => {
      const property = key.match(/^properties\[(.+)\]$/);
      if (property) payload.properties[property[1]] = value;
      else if (key === 'id' || key === 'quantity') payload[key] = Number(value);
      else if (key === 'selling_plan') payload.selling_plan = value;
    });
    if (!Object.keys(payload.properties).length) delete payload.properties;
    return payload;
  };

  const renderSections = async (ids) => {
    if (!ids.length) return {};
    try {
      const response = await fetch(`${root()}?sections=${ids.map(encodeURIComponent).join(',')}`);
      return response.ok ? await response.json() : {};
    } catch (error) {
      return {};
    }
  };

  const addToCart = async (form, submitter) => {
    const buttons = Array.from(form.elements).filter((el) => el.type === 'submit');
    const button = submitter || buttons[0];
    if (buttons.some((el) => el.getAttribute('aria-busy') === 'true')) return;

    setBusy(buttons, true);
    emit(document.documentElement, 'theme:loading:start');

    const payload = toPayload(form);
    let response = null;
    let json = {};
    try {
      response = await fetch(`${root()}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(payload),
      });
      json = await response.json();
    } catch (error) {
      json = { description: error.message };
    }

    setBusy(buttons, false);
    emit(document.documentElement, 'theme:loading:end');

    if (!response || !response.ok) {
      console.warn('[mp-cart] cart/add.js failed', response && response.status, payload, json);
      emit(form, 'cart:error', { error: json.description || json.message });
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      flashButton(button, json.description || json.message || 'Error');
      return;
    }

    const { cartType, pageType } = settings();
    if (cartType === 'page' || pageType === 'cart') {
      window.location.href = `${root()}cart`;
      return;
    }

    const sectionIds = [];
    emit(document.documentElement, 'cart:prepare-bundled-sections', { sections: sectionIds });

    let cart = {};
    try {
      cart = await (await fetch(`${root()}cart.js`)).json();
    } catch (error) {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }
    // The cart drawer's cart:change handler throws before opening the drawer unless cart.sections is an object.
    cart.sections = await renderSections(sectionIds);

    emit(form, 'variant:add', { items: json.items || [json], cart, onSuccessDo: null });
    emit(document.documentElement, 'cart:change', { baseEvent: 'variant:add', onSuccessDo: null, cart });

    if (cartType === 'message') flashButton(button, strings().addedToCart || 'Added to cart');
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-mp-atc')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    addToCart(form, event.submitter);
  }, true);
})();
